import {BaseViewModel} from "../../../../infrastructure/models/base-view-model";
import {RoundFilterDomainModel} from "./round-filter.domain-model";

export class RoundFilterViewModel extends BaseViewModel {
  domainModel: RoundFilterDomainModel;

  constructor(domainModel: RoundFilterDomainModel, index: Number) {
    super(domainModel);

    this.index = index
  }

  get id() {
    return this.index;
  }

  get title(): String {
    return this.domainModel.title;
  }

  get key(): String {
    return this.domainModel.key;
  }

  get isCurrent(): Boolean {
    return this.domainModel.isCurrent;
  }
}
